import React from 'react';
import PropTypes from 'prop-types';


const LayoutNoSidebar = props => {
    const {children, siteConfig} = props;
    return(
        <React.Fragment>
            <header className={`app-header navbar navbar-${siteConfig.styleName}`} style={{height: '75px'}}>
                <a className={`navbar-brand header-${siteConfig.styleName}`} href="#" style={{height: '60px', backgroundColor: 'inherit', marginTop: '5px'}} />
            </header>
            <div className="container" style={{position: 'relative', top: "100px"}}>
                { children }
            </div>
        </React.Fragment>
    );
};

LayoutNoSidebar.propTypes = {
  children: PropTypes.object.isRequired,
  siteConfig: PropTypes.object.isRequired,
};

export default LayoutNoSidebar;
